import { render } from "./EdicionUbicacion.vue?vue&type=template&id=526b39ad&scoped=true"
import script from "./EdicionUbicacion.vue?vue&type=script&lang=js"
export * from "./EdicionUbicacion.vue?vue&type=script&lang=js"

import "./EdicionUbicacion.vue?vue&type=style&index=0&id=526b39ad&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-526b39ad"]])

export default __exports__